module.exports = {"430422100":"云集镇","430422102":"廖田镇","430422103":"茶市镇","430422104":"冠市镇","430422105":"江口镇","430422106":"宝盖镇","430422107":"花桥镇","430422108":"铁丝塘镇","430422109":"泉溪镇","430422110":"洪山镇","430422111":"三塘镇","430422112":"谭子山镇","430422113":"鸡笼镇","430422114":"泉湖镇","430422115":"柞市镇","430422116":"茅市镇","430422117":"硫市镇","430422118":"栗江镇","430422119":"近尾洲镇","430422121":"咸塘镇","430422122":"松江镇","430422200":"相市乡","430422407":"衡州监狱"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430422.json
// module id = 1681
// module chunks = 0